import React from 'react';

import { Picker } from '../clientOnboarding/ClientOnboardingSlideOver';
import { VIEW_ONLY_TITLE } from '../onboardingSupport/ownership';

// "Who gets them?" on every Re-engage (Nic 2026-10-23), both pages.
//   A rep / specialist:   nothing to pick, they get them.
//   The Onboarding Manager: picks someone (himself included) first.
//   An admin or a viewer:  the picker and Re-engage show, greyed out.
// viewer = { canAct, isManager } from the board payload.

export const reengagePicks = (viewer) => !!viewer && (viewer.canAct === false || !!viewer.isManager);

// Can Re-engage be clicked yet?
export const reengageReady = (viewer, toUserId) => {
  if (viewer?.canAct === false) return false;
  return viewer?.isManager ? !!toUserId : true;
};

const ReengagePicker = ({ viewer, options = [], value, onChange, noun = 'rep', className = '' }) => {
  if (!reengagePicks(viewer)) return null;
  const locked = viewer.canAct === false;
  return (
    <div className={className} title={locked ? VIEW_ONLY_TITLE : undefined}>
      <Picker
        value={value}
        placeholder={`Who gets them? Pick a ${noun}`}
        options={options}
        onPick={onChange}
        disabled={locked}
        title={locked ? VIEW_ONLY_TITLE : undefined}
      />
    </div>
  );
};

export default ReengagePicker;
